import { GetRequest, PostRequestFile, PostRequest } from '../lib/request';

const LOGIN = `/auth/api/login`;
const REGISTER = `/auth/api/register`
const SUBMIT_FORGOT_PASSWORD = `/auth/api/submit-forgot-password`
const RESET_PASSWORD = `/auth/api/reset-password`
const CHANGE_PASSWORD = '/my-account/change-password'


export async function Login(data) {

    try {
        return await PostRequest(`${LOGIN}`, data);
    } catch (ex) {
        throw new Error("Unable to login");
    }
}


export async function Register(data) {

    try {
        return await PostRequest(`${REGISTER}`, data);
    } catch (ex) {
        if(ex){
            throw ex;
        }else{
            throw new Error("Unable to Register");
        }
    }
}

export async function SubmitForgotPassword(data){
    try {
        return await PostRequest(`${SUBMIT_FORGOT_PASSWORD}`, data);
    } catch (ex) {
        if(ex){
            throw ex;
        }else{
            throw new Error("Unable to submit Password Reset");
        }
    }
}

export async function ResetPassword(data){
    try {
        return await PostRequest(`${RESET_PASSWORD}`, data);
    } catch (ex) {
        if(ex){
            throw ex;
        }else{
            throw new Error("Unable to submit Password Reset");
        }
    }
}

export async function ChangePassword(data){
    try {
        return await PostRequest(`${CHANGE_PASSWORD}`, data);
    } catch (ex) {
        if(ex){
            throw ex;
        }else{
            throw new Error("Unable to submit Password Change");
        }
    }
}